import {
  SearchSearchProductAttribute,
  SearchSearchProductsResponse,
} from '@winelivery-org/wl-client-sdk-js/src/models/search/product';
import { upperFirst } from 'lodash';
import { useTranslations } from 'next-intl';
import { ChevronRight as IconChevronRight } from '../../../../../../../components/icons';
import { Link } from '@/i18n/routing';

interface Props {
  suggestions: SearchSearchProductsResponse;
  onClick?: () => void;
}

export default function Categories({ suggestions, onClick }: Props) {
  const t = useTranslations('shop');

  function handleClick() {
    if (onClick) {
      onClick();
    }
  }

  function getLink(attribute: SearchSearchProductAttribute) {
    return attribute.parent
      ? {
          pathname: '/shop',
          query: {
            category: attribute.parent.slug,
            subcategory: attribute.slug,
          },
        }
      : { pathname: '/shop', query: { category: attribute.slug } };
  }

  if (
    suggestions.categories.items.length === 0 &&
    suggestions.subcategories.items.length === 0
  ) {
    return null;
  }

  const items = [
    ...suggestions.categories.items,
    ...suggestions.subcategories.items,
  ].sort((a, b) => {
    const first = a.parent ? `${a.parent.name} - ${a.name}` : a.name;
    const second = b.parent ? `${b.parent.name} - ${b.name}` : b.name;
    return first.localeCompare(second);
  });

  return (
    <div className="">
      <h5 className="text-lg text-greyscale-title font-bold tracking-tighter m-0">
        {t('search.categories')}
      </h5>
      <ul className="divide-y divide-greyscale-separator m-0 p-0">
        {items.map((attribute) => (
          <li className="-mx-4" key={attribute.id}>
            <Link
              // @ts-expect-error
              href={getLink(attribute)}
              onClick={handleClick}
              className="cursor-pointer hover:bg-greyscale-background flex items-center py-2 px-4 text-greyscale-body no-underline hover:text-greyscale-body"
            >
              <span className="flex-1 text-base text-font-medium tracking-tight leading-5 truncate">
                {attribute.parent
                  ? `${upperFirst(attribute.parent.name)} - ${upperFirst(
                      attribute.name,
                    )}`
                  : upperFirst(attribute.name)}
              </span>
              <IconChevronRight className="shrink-0 h-5" />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
